import { SvgIconProps } from '@mui/material';

const DesktopArrowLeft = ({ width = '135', height = '215', className }: SvgIconProps) => (
  <svg width={width} height={height} viewBox="0 0 135 215" fill="none" className={className}>
    <g filter="url(#filter0_d_7450_371980)">
      <path
        d="M15.0006 16V127C15.0006 135.837 22.1641 143 31.0006 143H128.891"
        stroke="#E8E6DF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M13.5526 2.62912C14.2901 1.1568 16.3914 1.15681 17.129 2.62912L26.1294 20.5964C26.7956 21.9263 25.8286 23.4922 24.3412 23.4922L6.34034 23.4922C4.85292 23.4922 3.88596 21.9263 4.55215 20.5964L13.5526 2.62912Z"
        fill="#E8E6DF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_7450_371980"
        x="0.335938"
        y="0"
        width="134.555"
        height="215"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7450_371980" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7450_371980"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DesktopArrowLeft;
